export default "__VITE_ASSET__DTLkcq1k__"